import axios from '@/lib/axios';
import type { RegistrationParams } from '../../flatRates/types';

const confirmEditInfo = (data: RegistrationParams) => {
  return axios.post('/customer/edit_info/confirm', data);
}

export default confirmEditInfo;